import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit Planificación Express 12 Semanas',
  desc: 'El mapa paso a paso para organizar el trimestre en minutos.',
  value: '4.500',
  color: 'bg-blue-600'
}, {
  num: '02',
  title: 'Banco de Rúbricas y Criterios',
  desc: 'Evaluá informes, debates y laboratorios con rigor profesional.',
  value: '3.500',
  color: 'bg-teal-600'
}, {
  num: '03',
  title: 'Pack Clases Interactivas',
  desc: '+30 plantillas (Exit tickets, 3-2-1, Debates) para que el curso participe.',
  value: '3.500',
  color: 'bg-amber-600'
}];
export function BonusSection() {
  return <section className="py-14 md:py-24 px-4 bg-brand-dark text-white" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-8 md:mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-6xl font-black text-brand-orange mb-4 md:mb-6 uppercase tracking-tight" data-id="element-22">
            Más 3 Bonos Estratégicos
          </h2>
          <p className="text-2xl font-bold text-gray-300 mb-4" data-id="element-23">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <div className="inline-block bg-brand-green text-white text-2xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(0,178,122,0.5)]" data-id="element-24">
            🎁 GRATIS por el día de hoy
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-[#252542] rounded-2xl overflow-hidden border border-gray-700 shadow-2xl flex flex-col h-full" data-id="element-26">
              {/* 1080x1080 Aspect Ratio Image Placeholder */}
              <div className={`aspect-square ${b.color} p-8 flex flex-col items-center justify-center text-center relative`} data-id="element-27">
                <div className="absolute top-4 left-4 bg-white text-black font-black text-2xl px-4 py-1 rounded-lg" data-id="element-28">
                  {b.num}
                </div>
                <h3 className="text-3xl md:text-4xl font-black text-white leading-tight drop-shadow-md" data-id="element-29">
                  BONO {parseInt(b.num)}
                </h3>
                <p className="text-xl font-bold mt-4 text-white/90 drop-shadow-md px-4" data-id="element-30">
                  {b.title}
                </p>
              </div>

              <div className="p-5 md:p-8 flex flex-col flex-grow" data-id="element-31">
                <div className="flex items-center gap-2 mb-4" data-id="element-32">
                  <span className="text-2xl" data-id="element-33">🎁</span>
                  <h4 className="text-xl font-bold text-brand-orange" data-id="element-34">
                    BONO {parseInt(b.num)}
                  </h4>
                </div>
                <h5 className="text-2xl font-bold mb-4" data-id="element-35">{b.title}</h5>
                <p className="text-gray-300 text-lg mb-8 flex-grow" data-id="element-36">{b.desc}</p>

                <div className="mt-auto pt-6 border-t border-gray-700 flex justify-between items-center" data-id="element-37">
                  <div className="text-gray-400 font-medium" data-id="element-38">
                    Valor: <span className="line-through" data-id="element-39">${b.value}</span>
                  </div>
                  <div className="text-brand-green font-black text-2xl" data-id="element-40">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-[#252542] border-2 border-brand-orange rounded-2xl p-5 md:p-8 text-center max-w-3xl mx-auto" data-id="element-41">
          <p className="text-2xl text-gray-300 mb-2" data-id="element-42">
            Valor total de los 3 Bonos:{' '}
            <span className="line-through" data-id="element-43">$11.500 ARS</span>
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-44">
            🎁 GRATIS — Solo con tu compra. Siempre.
          </p>
        </div>
      </div>
    </section>;
}